module.exports = __webpack_public_path__ + "egg.png?11ffac10f23511d258ae77d89f4ae3e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/egg.png
// module id = 50
// module chunks = 0